'use strict';
var $export = require('./_export');
var $re = require('./_replacer')(/&(?:amp|lt|gt|quot|apos);/g, {
  '&amp;':  '&',
  '&lt;':   '<',
  '&gt;':   '>',
  '&quot;': '"',
  '&apos;': "'"
});

$export($export.P + $export.F, 'String', {unescapeHTML:  function unescapeHTML(){ return $re(this); }});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/core.string.unescape-html.js
 ** module id = 1260
 ** module chunks = 1
 **/